module.exports = "button {\n  margin-bottom: 0; }\n"


//////////////////
// WEBPACK FOOTER
// ./web/modern/components/admin/subscription-info/subscription-info-btn.scss
// module id = ./web/modern/components/admin/subscription-info/subscription-info-btn.scss
// module chunks = 0